module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img-upload', {
    attrs: {
      "image-preview-list": _vm.images,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "on-complete": _vm.onComplete,
      "before-upload": _vm.beforeUpload,
      "max": 9,
      "url": _vm.url,
      "extra-data": _vm.extraData,
      "is-preview": true,
      "is-clip": true,
      "clip-data": {
        width: 290,
        height: 290,
        rate: 3,
        background: '#fff'
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("后端接口地址："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("————————修改日志————————")]), _vm._v(" "), _c('p', [_vm._v("2018-01-18：修复IOS下微信只能打开相机的bug")]), _vm._v(" "), _c('p', [_vm._v("2018-01-04：新增图片裁剪的功能(只支持单张上传)")]), _vm._v(" "), _c('p', [_vm._v("2017-09-20：修复UC等浏览器上无法选择相册图片的bug")]), _vm._v(" "), _c('p', [_vm._v("2017-09-19：优化onSuccess钩子，添加onError、onComplete、beforeUpload等钩子")]), _vm._v(" "), _c('p', [_vm._v("2017-09-19：修复连续选取同一文件时不触发onchange事件的bug")]), _vm._v(" "), _c('p', [_vm._v("2017-09-18：迁移至vue2.0")]), _vm._v(" "), _c('p', [_vm._v("2016-12-05：添加图片点击预览大图功能")]), _vm._v(" "), _c('p', [_vm._v("2016-12-02：支持由外部传入的图片数组")]), _vm._v(" "), _c('p', [_vm._v("2016-11-30：发出请求后的回调处理改为由外部传入回调函数")]), _vm._v(" "), _c('p', [_vm._v("2016-11-27：v1.0，支持前端压缩、IOS图片方向修复、选择多张图片等功能")]), _vm._v(" "), _vm._m(0, false, false)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("confluence地址："), _c('a', {
    attrs: {
      "href": "http://confluence.daojia-inc.com/pages/viewpage.action?pageId=32675115",
      "target": "_blank"
    }
  }, [_vm._v("html5移动端上传图片的解决方案及vue实现（v1.0）")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57da2ff5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57da2ff5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 85
// module chunks = 0